import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-xlsx-file-icon',
  templateUrl: './doc-format-xlsx-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatXlsxFileIconComponent {}
